export const REASON_NOT_FOUND = 'NOT_FOUND';
export const REASON_CREATING_STUDENT = 'CREATING_STUDENT';
export const RECHECK_INTERVAL = 5000;
export const PROGRAM_PT = 'PT';
export const PROGRAM_ADN = 'ADN';
export const APP_ENVIRONMENT = process.env.REACT_APP_API_STAGE;

export const statusTypes = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  DANGER: 'danger',
  DEFAULT: 'default',
  INFO: 'info'
};

export const terms = {
  Sp: 'Spring',
  Su: 'Summer',
  F: 'Fall',
  W: 'Winter'
};

export const grades = [
  "A",
  "A-",
  "B+",
  "B",
  "B-",
  "C+",
  "C",
  "C-",
  "D",
  "F",
  "W",
  "FW",
  "I"
];

export const unitTypes = {
  Q: 'Quarter',
  S: 'Semester'
};

export const unitOptions = [
  '0',
  '0.5',
  '1.0',
  '1.5',
  '2.0',
  '2.5',
  '3.0',
  '3.5',
  '4.0',
  '4.5',
  '5.0',
  '5.5',
  '6.0'
];

export const degreeLevels = {
  AA: "Associate's",
  BA: "Bachelor's",
  MA: "Master's",
  PhD: "Doctorate"
};

export const licenseTypes = {
  LVN: 'LVN',
  PT: 'Psychiatric Technician',
  RT: 'Radiologic Technologist',
  ReT: 'Respiratory Therapist',
  P: 'Paramedic'
};

export const certificateTypes = {
  NA: 'Nursing Assistant',
  HHA: 'Home Health Aide',
  EMT: 'Emergency Medical Technician'
};

export const scienceRequirements = {
  anatomy: 'Human Anatomy',
  physiology: 'Human Physiology',
  micro: 'Microbiology'
};

export const nonScienceRequirements = {
  english: 'English',
  humanDev:'Human Development'
};

export const nonGpaRequirements = {
  math: 'Math'
};

export const optionalRequirements = {
  nutrition: 'Nutrition',
  pharmacology: 'Pharmacology',
  medTerminology: 'Medical Terminology'
};

export const upgradeRequirements = {
  nursingSynthesis: 'Nursing Synthesis'
};

export const courseRequirements = {
  ...scienceRequirements,
  ...nonScienceRequirements,
  ...nonGpaRequirements
};

export const ptCourseRequirements = {
  anatomy: 'Human Anatomy',
  medTerminology: 'Medical Terminology',
  humanDev: 'Human Development',
  psychology: 'Introduction to Psychology'
};

export const ptOtherCourses= {
  physiology: 'Human Physiology',
  nutrition: 'Nutrition'
};

export const combinedPTOptions = {
  ...ptCourseRequirements,
  //anatomyphysiology: 'Human Anatomy and Physiology'
}

export const combinedCourseOptions = {
  ...combinedPTOptions,
  ...courseRequirements,
  ...optionalRequirements,
  ...upgradeRequirements,
  ...ptOtherCourses
}

export const ethnicities = [
  "Hispanic/Latino",
  "Mexican/Mexican-American/Chicano",
  "Central American",
  "South American",
  "Other Hispanic",
  "Asian Indian",
  "Chinese",
  "Japanese",
  "Korean",
  "Laotian",
  "Cambodian",
  "Vietnamese",
  "Filipino",
  "Other Asian",
  "Black/African American",
  "American Indian/Alaskan Native",
  "Guamanian",
  "Hawaiian",
  "Samoan",
  "Other Pacific Islander",
  "White"
];

export const foreignLanguages = {
  asl: 'American Sign Language',
  arabic: 'Arabic',
  chinese: 'Chinese, including its various dialects',
  farsi: 'Farsi',
  russian: 'Russian',
  spanish: 'Spanish',
  tagalog: 'Tagalog',
  other: 'Other'
};

export const confirmations ={
  deltaEmail: 'I understand that all correspondence regarding this application will be sent to my Delta College student email address.',
  timelines: 'I understand that it is MY RESPONSIBILITY to review and respond to requests for information in a timely manner and within prescribed timelines. I further understand that failure to review and respond to information within prescribed timelines may result in my disqualification from this filing period.',
  eligibility: 'I understand that the information I submit in my application is used to determine my eligibility for the program.',
  documentation: 'I understand that if I am invited to submit documentation (e.g., transcript and course descriptions), that I must provide documentation to support the information included in my application. Failure to submit all required documentation AND inconsistent information between the documentation and application will result in disqualification for the filing period.',
  faq: 'I have reviewed the admission criteria and read the Frequently Asked Questions on the Health Science webpage.',
  application: 'I understand that it is my responsibility to review my application information (below) before I submit this application.',
  changes: 'I understand that once I SUBMIT this application for processing, no changes can be made.',
  accurate: 'I verify that my application is accurate and complete to the best of my knowledge.',
  disqualification: 'I further understand that the submission of inaccurate information will result in disqualification of my application for the filing period.'
};

export const applicationStatuses = {
  INCOMPLETE: {
    code: 'IN',
    text: 'Incomplete',
    description: ['The application has been created but has not been submitted.'],
    level: 0
  },
  PENDING: {
    code: 'P',
    text: 'Pending',
    description: ['The application has been submitted but has not been denied or invited to submit further documentation.', 'Check back around the notification date for further details.'],
    level: 1
  },
  INVITED: {
    code: 'I',
    text: 'Invited',
    description: ['Based on your online application, we are inviting you to submit all required documentation in support of your application. ' +
      'Please be advised that failure to submit ALL required documentation at one time will result in a disqualification from considered admission into the program.',
      'After all documentation has been verified and evaluated, a final ranking will be prepared. Please DO NOT CALL the Health Science Office regarding the status of your application.' +
      'Your documentation is due by 4pm on the Supporting Documentation Deadline date for the period.',
      'Final Ranking is expected to be completed by the Final Ranking date. Please check back then.',
      'You can view the supporting documentation checklist below.'],
    files: [
      {
        programId: PROGRAM_ADN,
        title: 'Documentation Checklist',
        path: '/documents/ADN Documentation Checklist.pdf'
      },
      {
        programId: PROGRAM_PT,
        title: 'Documentation Checklist',
        path: '/documents/PT Documentation Checklist.pdf'
      }
    ],
    level: 2
  },
  NOT_INVITED: {
    code: 'NI',
    text: 'Not Invited',
    description: ['You have not been invited to submit supporting documentation at this time.'],
    level: 2
  },
  ACCEPTED: {
    code: 'AC',
    text: 'Accepted',
    description: ['Congratulations! Based on your evaluation, you have been conditionally accepted for enrollment. ' +
      'Please accept or decline your spot in the program.'],
    level: 3
  },
  DISQUALIFIED: {
    code: 'DQ',
    text: 'Disqualified',
    description: ['You have been disqualified from the program for this application period. Feel free to' +
      'try again next application period.'],
    level: 1
  },
  ADMITTED: {
    code: 'AD',
    text: 'Admitted',
    description: ['You have been admitted into the program.'],
    level: 4
  },
  DECLINED: {
    code: 'DC',
    text: 'Declined',
    description: ['You have declined your spot in the program.'],
    level: 4
  },
  ALTERNATE: {
    code: 'AL',
    text: 'Alternate',
    description: ['You are currently on the alternate list for the program.'],
    level: 3
  },
  NOT_ADMITTED: {
    code: 'NA',
    text: 'Not Admitted',
    description: ['You have not been admitted into the program.'],
    level: 3
  },
  DEFERRED: {
    code: 'DE',
    text: 'Deferred',
    description: ['You have been moved to deferred status.'],
    level: 1
  }
};

export const pointCategories = [
  {
    id: '1A',
    type: 'points',
    text: 'Academic Degrees'
  }, {
    id: '1B',
    type: 'points',
    text: 'Licensed Health Care and Work Experience'
  }, {
    id: '1C',
    type: 'points',
    text: 'Certificates and Work Experience'
  }, {
    id: '1D',
    type: 'points',
    text: 'Other Certificates, Licenses, and Work Experience'
  }, {
    id: '1',
    type: 'section',
    text: 'Section 1 Total'
  }, {
    id: '2A',
    type: 'points',
    text: 'Science Prerequisite GPA'
  }, {
    id: '2B',
    type: 'points',
    text: 'Non-Science Prerequisite GPA'
  }, {
    id: '2C',
    type: 'points',
    text: 'Repeats in Science Requirements'
  }, {
    id: '2',
    type: 'section',
    text: 'Section 2 Total'
  }, {
    id: '3',
    type: 'points',
    text: 'Life Experience'
  }, {
    id: '4',
    type: 'points',
    text: 'Proficiency in languages other than English'
  }, {
    id: '5',
    type: 'points',
    text: 'Test of Essential Academic Skills (TEAS)'
  }, {
    id: '6',
    type: 'status',
    text: 'Math Requirement'
  }, {
    id: '7',
    type: 'points',
    text: 'Highly Recommended Coursework'
  }, {
    id: 'total',
    type: 'total',
    text: 'Total Points'
  }
];

export const messages = {
  AUTH_SUCCESS: 'Authenticated with Okta',
  AUTH_REQUEST: 'Authenticating with Okta',
  CREDENTIALS_REQUEST: 'Requesting credentials from AWS',
  CREDENTIALS_SUCCESS: 'Credentials received from AWS',
  LOGIN_COMPLETE: 'Login Complete',
  PERIODS_REQUEST: 'Getting application periods.',
  FETCH_USER_REQUEST: 'Getting your student profile.',
  FETCH_APPLICATION_REQUEST: 'Loading your application.',
  UPDATE_APPLICATION_REQUEST: 'Saving application.',
  UPDATE_APPLICATION_STATUS_REQUEST: 'Updating application status.',
  SUBMIT_APPLICATION_REQUEST: 'Submitting application.'
};

export const DEBUG = process.env.REACT_APP_DEBUG ? process.env.REACT_APP_DEBUG : false;

